import React from 'react'
import {
    FormControl,
    Input,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Text,
    Stack,
  } from '@chakra-ui/react';

function ProductDimension(props) {
    console.log(props,'PROPS')
  return (
    <>
    <Text fontSize='2xl'>Dimension</Text>
    <FormControl>
    <FormLabel>Product Weight :  {props['data']['productWeight']} gram</FormLabel>
    </FormControl>    
    <Stack spacing={4} direction='row' align='center'>
        <FormControl>
            <FormLabel>Height</FormLabel>
            <FormLabel>{props['data']['productHeight']} cm</FormLabel>
        </FormControl>    
        <FormControl>
            <FormLabel>Length</FormLabel>
            <FormLabel>{props['data']['productLength']} cm</FormLabel>
        </FormControl>    
        <FormControl>
            <FormLabel>Width</FormLabel>
            <FormLabel>{props['data']['productWidth']} cm</FormLabel>
        </FormControl>    

    </Stack>    
    </>
  )
}

export default ProductDimension